import React from 'react';
import './PageLoader.css';

/**
 * PageLoader — Full-overlay spinner shown while a page/component is mounting.
 * Rendered by each account page via the usePageLoader hook.
 */
function PageLoader({ message = 'Loading…' }) {
    return (
        <div className="page-loader-overlay" aria-live="polite" aria-label={message}>
            <div className="page-loader-box">
                <div className="page-loader-spinner" />
                <span className="page-loader-text">{message}</span>
            </div>
        </div>
    );
}

export default PageLoader;